// extracted by mini-css-extract-plugin
module.exports = {"dbIframe":"b8_lj","dbIframe__loader":"b8_lk","dbIframe__loaderExcel":"b8_ll","dbIframe__loaderLoading":"b8_lm","dbIframe_isLoaded":"b8_ln","dbIframe__iframe":"b8_lp"};